import Vue from 'vue';
import Autocomplete from '@trevoreyre/autocomplete-vue';

Vue.use(Autocomplete);
